<template>
<div class="JZJL">
  <div class="boxs"  ref='jzjls' @scroll="handleScroll">
    <div v-for="item in list">
      <div>
        <div class="box-content">
          <div style="display: flex;align-items: flex-start">
            <p class="cz"><span>初</span></p>
            <div class="wzxx">
              <p>就诊门店：{{item.SimpleShop.ShopName?item.SimpleShop.ShopName:'无'}}</p>
              <p>咨询编号：{{item.bh}}</p>
              <p>创建时间：{{item.ChooseAddTime}}</p>
              <p v-if="item.SimpleExpert">专<span style="padding-left: 2em"></span>家：{{item.SimpleExpert.ExpertName}}</p>
              <div class="hzbq">
                <p v-for="items in item.ListChooseStep">{{items}}</p>
              </div>
            </div>
            <!--          <div v-if="item.iswc == 'sgsqm'" class="iswc">视光师签名</div>-->
            <!--          <div v-if="item.iswc == 'ysqm'" class="iswc">医生签名</div>-->
          </div>
          <div class="wxfn">
            <p @click="ckbg(item.ChooseId)">查看报告</p>
            <p v-if="showkz && isToday(item.ChooseAddTime)" @click="hjjz(item.ChooseId)">呼叫就诊</p>
            <p @click="gos(item.ChooseId, item.ChooseSignPath, item.ChooseOptometristSignPath, item)">进入诊疗</p>
            <p  @click="addfz(item.ChooseId)">+添加复诊</p>
<!--            <p style="margin: 0" v-if="showkz"  @click="hjjz(item.ChooseId)">呼叫就诊</p>-->
          </div>
        </div>


        <div style="display: flex;justify-content: right;width: 100%;">
          <div style="width: 90%">
            <div class="box-content" style="width: 100%;" v-for="items in item.ListSonChoose">
              <div style="display: flex;align-items: flex-start">
                <p class="fc"><span>复</span></p>
                <div class="wzxx">
                  <p>就诊门店：{{items.SimpleShop.ShopName?items.SimpleShop.ShopName:'无'}}</p>
                  <p>咨询编号：{{items.ChooseId.slice(0,8).toUpperCase()}}</p>
                  <p>创建时间：{{items.ChooseAddTime}}</p>
                  <p v-if="items.SimpleExpert">创<span style="padding-left: 0.5em"></span>建<span style="padding-left: 0.5em"></span>人：{{items.SimpleExpert.ExpertName}}</p>
                  <div class="hzbq" style="width: calc(100vw - 700px)">
                    <p v-for="itemp in items.ListChooseStep">{{itemp}}</p>
                  </div>
                </div>
                <!--          <div v-if="item.iswc == 'sgsqm'" class="iswc">视光师签名</div>-->
                <!--          <div v-if="item.iswc == 'ysqm'" class="iswc">医生签名</div>-->
              </div>
              <div class="wxfn">
                <p @click="ckbg(items.ChooseId)">查看报告</p>
                <p v-if="showkz && isToday(item.ChooseAddTime)" @click="hjjz(items.ChooseId)">呼叫就诊</p>
                <p  @click.stop="gos(items.ChooseId,'','', items)">进入诊疗</p>
                <!--      <p style="margin: 0">+添加复诊</p>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div style="padding-top: 10px;">
    <el-button type="primary" @click="xjcz">新建初诊</el-button>
  </div>

  <el-dialog
      title="报告详情"
      :visible.sync="showyy"
      width="80%"
  >
    <iframe class="znr" ref="prints" :src="src"></iframe>
  </el-dialog>
</div>
</template>

<script>
import pf from "@/publicFn/baseFn"

export default {
  name: "JZJL",
  data() {
    return {
      list: [],
      fy: 50,
      src: '',
      showyy: false,
      showkz: false
    }
  },
  watch: {
    '$store.state.users.CsUser':function (n, o)  {
      // console.log(n)
      if (n) {
        this.fy = 50
        this.getData()
      }else {
        this.list = []
      }
    }
  },
  created() {
    if (this.$store.state.users.CsUser) {
      this.getData()
    }

    if (this.$store.state.users.user.Company.CompanyId == 'cde7287b-c391-11f0-b631-0c42a1b79076') {
      this.showkz = true
    }

    let _this = this
    window.localRequestResult  =  function (str) {
      console.log(str)
      let obj = JSON.parse(str)
      _this.$alert(obj.msg,'提示')
    }
  },
  methods: {
    gos(id, url, sgurl, item) {
      if (url) {
        this.$store.commit('physicianVisits/upIsqm', false)
      }
      if (sgurl) {
        this.$store.commit('physicianVisits/upissgqm', false)
      }
      pf.clCsData()


      this.$store.commit('physicianVisits/upXzConsulting', id)
      this.$store.commit('physicianVisits/upJump', 1)
      this.$store.commit('users/upCsObj', JSON.parse(JSON.stringify(item)))
      this.$router.push({path: '/'})



    },
    addfz(id) {
      if (!this.$store.state.users.employees) {
        this.$alert("专家未登录，请先登录", "提示")
            .then(res => {
              this.$router.push({
                path: '/employeesLanding',
                query: {types: 1001}
              })
            })
        return
      }
      this._api.physicianVisits.addNewChoose(id)
          .then(res => {
            if (res.msg != 'Success') {
              this.$alert(res.msg, '提示')
              return
            }
            if (res.InsertResult) {
              // this.sx = true
              pf.clCsData()
              this.$store.commit('physicianVisits/upXzConsulting',  res.InsertResult.Choose.ChooseId)
              this.$store.commit('users/upCsObj', JSON.parse(JSON.stringify(res.InsertResult.Choose)))
              this.$store.commit('physicianVisits/upJump', 1)
              pf.initTime()
              this.$router.push({path: '/'})
            }
          })
    },
    getData() {
      let loadingInstance = this.$loading({
        background: 'rgba(0, 0, 0, 0.7)',
        text: '加载中...'
      })
      this._api.userCurdApi.getCsConsulting(this.fy)
          .then(res => {
            // console.log(res)
            loadingInstance.close();
            let fcObj = {}
            if (res.GetListWithBusinessResult && res.GetListWithBusinessResult.length > 0) {
              // let time = res.GetListWithBusinessResult[0].ChooseAddTime.split(' ')[0]
              // time = time.replace(/\//g, '-')
              // time==getTimeNo(0)?this.sj = 1:this.sj = 0
              this.fy = this.fy + 50
              this.list = res.GetListWithBusinessResult.map((item, idx) => {
                if (item.ChooseStep) {
                  if (item.ChooseStep.indexOf('CL_RE_FC') > -1) {
                    item.ListChooseStep.length ? item.ListChooseStep.push('眼底相机') : item.ListChooseStep = ['眼底相机']
                  }
                }



                if (item.ChooseStep.indexOf('InspectionTraining') > 0 || item.ChooseStep.indexOf('InspectionTrainingDetail') > 0) {
                  item.ListChooseStep.push('视觉训练')
                }

                if (item.ChooseStep) {
                  if (item.ChooseStep.indexOf('CL_RE_OCT') > -1) {
                    item.ListChooseStep.length ? item.ListChooseStep.push('OCT') : item.ListChooseStep = ['OCT']
                  }
                }
                if (item.ChooseStep) {
                  if (item.ChooseStep.indexOf('DoctorSign') > -1) {
                    item.iswc = 'ysqm'
                  }
                  if (item.ChooseStep.indexOf('OptometristSign') > -1) {
                    item.iswc = 'sgsqm'
                  }
                }
                if (item.ListSonChoose && item.ListSonChoose.length) {
                  fcObj[idx] = [...item.ListSonChoose]
                }
                if (!item.SimpleShop) {
                  item.SimpleShop = {
                    ShopName: '无'
                  }
                }
                if (!item.SimpleUser) {
                  item.SimpleUser = {
                    UserFullName: '无'
                  }
                }
                if (!item.SimpleExpert) {
                  item.SimpleExpert = {
                    ExpertName: '无'
                  }
                }
                item.bh = item.ChooseId.slice(0,8).toUpperCase()
                return item
              })
            }else {
              this.list = []
            }
          })
          .catch(err => {
            loadingInstance.close();
          })
    },
    ckbg(id) {
      let CustomerId = this.$store.state.users.CsUser.CustomerId
      this.src = `https://c.visumall.com/report/customer/inquirydetailReport.aspx?CustomerId=${CustomerId}&ChooseId=${id}`
      // this.src = this._getUrl('ChooseReport_MR') + `CustomerId=${this.$store.state.users.CsUser.CustomerId}&ChooseId=${id}&ExpertId=${exid}`
      this.showyy = true
    },
    xjcz() {
      if (!this.$store.state.users.employees) {
        this.$alert("专家未登录，请先登录", "提示")
            .then(res => {
              this.$router.push({
                path: '/employeesLanding',
                query: {types: 1001}
              })
            })
        return
      }
      let loadingInstance = this.$loading({
        background: 'rgba(0, 0, 0, 0.7)',
        text: '加载中...'
      })
      this._api.physicianVisits.addNewChoose()
          .then(res => {
            loadingInstance.close()
            if (res.InsertResult) {
              pf.clCsData()
              this.$store.commit('physicianVisits/upIsqm', true)
              this.$store.commit('physicianVisits/upissgqm', true)
              this.$store.commit('physicianVisits/upXzConsulting',  res.InsertResult.Choose.ChooseId)
              this.$store.commit('physicianVisits/upJump', 1)
              this.$store.commit('users/upCsObj', JSON.parse(JSON.stringify(res.InsertResult.Choose)))
              this.$router.push({path: '/'})
            }
          })
    },
    handleScroll() {
      const el = this.$refs.jzjls;
      if (el.scrollHeight - el.scrollTop <= el.clientHeight + 1) {
        this.getData();
      }
    },
    hjjz(csid) {
      if (!this.$store.state.users.employees) {
        this.$router.push({
          path: '/employeesLanding'
        })
      }
      let log = this.$loading({text: '加载中...'})
      this._api.userCurdApi.KZ_GetToHISParam(csid)
      .then(res => {
        log.close()
        if (res.Result) {
          if (window.bound) {
            window.bound.localRequest('http://192.168.0.60:8092/beacon/api/Visumall/inClcDtmain', JSON.stringify(res.Result));
          }
        }else {
          this.$alert(res.displaymsg, '提示')
        }
      })

    },
    isToday(dateValue) {
      // 将传入的值统一转换为 Date 对象
      const inputDate = new Date(dateValue);

      // 检查是否为有效日期，防止传入无效参数导致报错
      if (isNaN(inputDate.getTime())) {
        return false;
      }

      // 获取当前的系统时间
      const today = new Date();

      // 比较年、月、日是否完全相同
      return inputDate.getFullYear() === today.getFullYear() &&
          inputDate.getMonth() === today.getMonth() &&
          inputDate.getDate() === today.getDate();
    }
  }
}
</script>

<style scoped lang="scss">
.boxs {
  height: calc(100vh - 300px);
  overflow-y: auto;
}
.box-content {
  border-radius: 10px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.15);
  display: flex;
  margin-bottom: 15px;
  padding: 10px 0;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;
}
.hjjz {
  border: 1px solid #7f7e7e;
  display: inline-block;
  padding: 3px 10px !important;
  cursor: pointer;
  border-radius: 5px;
}
.cz {
  padding: 2px;
  border-radius: 5px;
  border: 1px solid #1d35a1;
  margin-left: 17px;
  span {
    display: block;
    border-radius: 5px;
    border: 1px solid #1d35a1;
    padding: 0 3px;
    font-size: 15px;
    font-weight: 400;
    color: #1d35a1;
  }
}
.fc {
  padding: 2px;
  border-radius: 14px;
  border: 1px solid rgba(153, 153, 153, 1);
  margin-left: 17px;
  span {
    display: block;
    border-radius: 11px;
    border: 1px solid rgba(153, 153, 153, 1);
    padding: 0 3px;
    font-size: 15px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
  }
}

.hzbq {
  width: calc(100vw - 520px);
  display: flex;
  flex-wrap: wrap;
  padding-top: 10px;
  p {
    height: 24px !important;
    padding: 0 5px !important;
    border: 1px solid #1d35a1;
    background: #FFFFFF;
    color: #1d35a1;
    border-radius: 5px;
    margin-right: 10px;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 5px;
  }
}

.wzxx {
  font-size: 15px;
  font-weight: 400;
  color: rgba(105, 105, 105, 1);
  text-align: left;
  padding-left: 20px;
  position: relative;
  p{padding-bottom: 8px}
  p:nth-child(4){padding: 0;}
  @media (max-width: 768px) {
    font-size: 12px;
    width: calc(100vw - 430px);
  }
}
.wxfn {
  position: relative;
  top: -6px;
  padding-right: 25px;
  @media (max-width: 768px) {
    padding-right: 15px;
  }
  p {
    width: 95px;
    border-radius: 5px;
    font-size: 15px;
    font-weight: 400;
    color: rgba(168, 168, 168, 1);
    border: 1px solid rgba(168, 168, 168, 1);
    padding: 5px 0;
    margin-bottom: 12px;
    cursor: pointer;
    @media (max-width: 768px) {
      font-size: 12px;
      width: 80px;
    }
  }
  p:nth-child(2) {
    color: #1d35a1;
    border: 1px solid #1d35a1;
  }
}

.znr {
  width: 100%;
  height: 70vh;
  overflow-y: auto;
}

.iswc {
  position: absolute;
  top: 10px;
  left: 40vw;
  font-size: 16px;
  color: #7f7e7e;
  width: 6em;
  height: 6em;
  border-radius: 50%;
  border: 1px solid #7f7e7e;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
